module.exports = __webpack_public_path__ + "static/media/Adding a Client File.4027ac1f.png";